var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#CC214F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6128 14.2459C19.219 13.1329 20.8169 13.1329 21.4231 14.2459L27.0809 24.6341C27.6616 25.7002 26.8898 26.9993 25.6758 26.9993H14.3601C13.146 26.9993 12.3743 25.7002 12.955 24.6341L18.6128 14.2459Z",
    stroke: "#CC214F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1853 18.1342C19.1745 17.6767 19.5424 17.3 20 17.3C20.4576 17.3 20.8255 17.6767 20.8147 18.1342L20.7497 20.889C20.7401 21.2962 20.4073 21.6212 20 21.6212C19.5928 21.6212 19.26 21.2962 19.2503 20.889L19.1853 18.1342Z",
    fill: "#CC214F",
    stroke: "#CC214F",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7217 24.4317C20.5199 24.6134 20.2757 24.7039 19.9999 24.7039C19.7242 24.7039 19.48 24.6134 19.2782 24.4317C19.0758 24.2496 18.9666 24.0205 18.9666 23.7539C18.9666 23.4873 19.0758 23.2582 19.2782 23.0761C19.48 22.8945 19.7242 22.8039 19.9999 22.8039C20.2757 22.8039 20.5199 22.8945 20.7217 23.0761C20.924 23.2582 21.0333 23.4873 21.0333 23.7539C21.0333 24.0205 20.924 24.2496 20.7217 24.4317Z",
    fill: "#CC214F",
    stroke: "#CC214F",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledWarning);
export default __webpack_public_path__ + "static/media/circled-warning.a4a9ab90154fafbae2b77f401a8a42e1.svg";
export { ForwardRef as ReactComponent };